import React from 'react'
import { MessageStyled } from './ProvideExtraPersonalIdMessage.styles'
import { CustomerServiceTelephone } from '@mobi/component-library/Base/Link'
import { useFeature } from '@core/Utils/hooks'
import { FeatureFlags } from '@mobi/settings/featureFlags'

export const ProvideExtraPersonalIdMessage = () => {
  const isAmlRiskAssessed = useFeature(FeatureFlags.AML_SIGNUP_RISK_ASSESSMENT.key)
  return (
    <MessageStyled>
      To increase the success of re-verification please provide additional information such as{' '}
      <strong>Driver's Licence</strong>, <strong>Passport</strong>
      {!isAmlRiskAssessed && (
        <>
          , <strong>Medicare Card</strong>
        </>
      )}{' '}
      or call <CustomerServiceTelephone /> for assistance.
    </MessageStyled>
  )
}
